import { useState } from "react"
import { Alert, Button, Col, Image, Modal, Row } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import { FaDownload } from "react-icons/fa"
import Get from "../../api/Get"
import { GET_CHECKLIST_DOCUMENTS } from "../../api/Routes"
import iconRecheck from '../../img/icons/recheck.svg'
import SimpleLoad from "../../loader/SimpleLoad"
import ComponentModalErrorSever from "../ComponentModalErrorSever"

function DescargarDocumentos({t, auth, id, appoinmentStatus}){
    const [sendingDoc, setSendingDoc] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const [showModalServer, setShowModalServer] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const [modalShow, setModalShow] = useState(false)
    const [docuemntosEnviar, setDocumenosEnviar] = useState(null)
    const [existDocuments, setExistsDocuments] = useState(true)
    
    const handleCloseSuccess = () => setShowSuccess(false);
    const handleCloseModalServer = () => setShowModalServer(false)
    const handleCloseModal = () => setModalShow(false);

    const documentosParaDescargar = async () =>{
        setModalShow(true);
        setSendingDoc(true)
        setExistsDocuments(true)
        try {
            const response = await Get({url: `${GET_CHECKLIST_DOCUMENTS}/${id}`, access_token: auth.data.access_token})
            //console.log(response)
            if(response.data.state){
                setSendingDoc(false)
                setDocumenosEnviar(response.data.data)
                if(!response.data.data.ficha && !response.data.data.historia && !response.data.data.receta
                    && !response.data.data.incapacidad && !response.data.data.recomendacion && !response.data.data.remision
                    && !response.data.data.estudios && !response.data.data.laboratorio && !response.data.data.consentimientoInformado
                    && !response.data.data.notas){
                        setExistsDocuments(false)
                }
            }else{
                setSendingDoc(false)
                setDocumenosEnviar(null)
                setExistsDocuments(false)
            }
        } catch (error) {
            setSendingDoc(false)
            setShowModalServer(true)
            setErrorServer(error?.response)
        }
    }

    return (
        <>
            <div className="text-center">
                <Button size="sm" 
                    variant="outline-secondary" 
                    className="font-size-07rem py-0"
                    onClick={documentosParaDescargar}
                    block
                >
                    <FaDownload className="pb-1" />
                    Descargar
                </Button>
            </div>
            <Modal show={showSuccess} onHide={handleCloseSuccess} centered className="border-0">
                <Modal.Body className="p-0">
                    <div className="text-center position-relative overflow-hidden h-100p">
                        <Image src={iconRecheck} fluid className="img-recheck"/>
                        <h5 className="mb-0 text-app-success"> {t('solicitud_exitosa')} </h5>
                    </div>                
                </Modal.Body>
            </Modal>
            <ComponentModalErrorSever
                show={showModalServer}
                handleClose={handleCloseModalServer}
                error={errorServer}
            />
            <Modal show={modalShow} onHide={handleCloseModal} centered className="border-0">
                {sendingDoc && <SimpleLoad />}
                <Modal.Header>Documentos</Modal.Header>
                <Modal.Body>
                    {
                        !existDocuments && 
                        <Alert variant="info">No existen documentos a descargar</Alert>
                    }
                    <ul>
                        {docuemntosEnviar?.ficha && 
                            <li>
                                <a href={docuemntosEnviar.urlFicha} target="blank">Ficha epidemiológica.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.historia && 
                            <li>
                                <a href={docuemntosEnviar.urlHistoria} target="blank">Historia clínica.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.receta && 
                            <li>
                                <a href={docuemntosEnviar.urlReceta} target="blank">Receta.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.incapacidad && 
                            <li>
                                <a href={docuemntosEnviar.urlIncapacidad} target="blank">Incapacidad.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.recomendacion && 
                            <li>
                                <a href={docuemntosEnviar.urlRecomendacion} target="blank">Recomendación médica.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.remision && 
                            <li>
                                <a href={docuemntosEnviar.urlRemision} target="blank">Remisiones.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.estudios && 
                            <li>
                                <a href={docuemntosEnviar.urlEstudios} target="blank">Estudios imagenológicos.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.laboratorio && 
                            <li>
                                <a href={docuemntosEnviar.urlLaboratorio} target="blank">Laboratorios.</a>                                
                            </li>
                        }
                        {
                            docuemntosEnviar?.notas &&
                            <li>
                                <a href={docuemntosEnviar.urlNotas} target="blank">Notas Aclaratorias.</a>
                            </li>
                        }
                        {(docuemntosEnviar?.consentimientoInformado && (appoinmentStatus === 'Pagada' || appoinmentStatus === 'Fallida')) && 
                            <li>
                                <a href={docuemntosEnviar.urlConsentimiento} target="blank">Consentimiento informado.</a>                                
                            </li>
                        }
                    </ul>

                    <Row>
                        <Col className="text-right">
                            <Button 
                                variant="primary" 
                                className="btn1"
                                onClick={handleCloseModal}
                            >Aceptar</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )

}

export default withTranslation()(DescargarDocumentos)